module.exports = __webpack_public_path__ + "static/media/sk-SK.2fc05b29.md";